import React, { useState } from 'react'
import "./GurmatQuiz.css"

const GurmatQuiz = () => {
    const [showForm, setShowForm] = useState(false);
    return (
        <div className="ielts-wrapper">
            {!showForm && <div style={{textAlign: "center"}}>
                <div className="ielts-banner">
                    {/* For Destop */}
                    <img src="/assets/GTB-Destop.jpg" className='max-[767px]:hidden' alt="IELTS Free Course" />
                    {/* For Mobile */}
                    <img src="/assets/GTB-Mob.jpg" className='md:hidden' alt="IELTS Free Course" />
                </div>

                <button
                    className="ielts-btn"
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? "Close Form" : "Enroll Now for Gurmat Quiz"}
                </button>
            </div>
            }

            {/* Iframe */}
            {showForm && (
                <div className="ielts-iframe fade-in">
                    <iframe
                        aria-label="Gurmat Quiz Enrollment Form"
                        title="Gurmat Quiz Enrollment Form"
                        src="https://forms.zohopublic.com/globedwise/form/GurmatQuizEnrollmentForm/formperma/Y4uOc4b-hhZ0OH9LN9-7eojpSXwRX1InuN8xfJMMtUQ"
                        frameBorder="0"
                        style={{ height: "1100px", width: "100%", border: "none" }}
                    ></iframe>
                </div>
            )}
        </div>
    )
}

export default GurmatQuiz
